import { Component, Host, Prop, h, Element } from '@stencil/core';
@Component({
  tag: 'cms-toggle',
  shadow: false,
})
export class CmsToggle {
  /**
   * The original value of the display property of style  for the button.
   */
  @Prop() dataButtonDisplay: string = 'inline-block';

  /**
   * The original value of the display property of style  for the content.
   */
  @Prop() dataContentDisplay: string = 'block';

  @Element() elRoot: HTMLElement;

  componentDidLoad() {
    const btnOpen: HTMLElement = this.getOpenElement();
    const btnClose: HTMLElement = this.getCloseElement();
    const content: HTMLElement = this.getContentElement();
    if (btnOpen && btnClose && content) {
      btnOpen.addEventListener('click', this.handleClickOpen);
      btnClose.addEventListener('click', this.handleClickClose);
    }
  }

  disconnectedCallback() {
    const btnOpen: HTMLElement = this.getOpenElement();
    const btnClose: HTMLElement = this.getCloseElement();
    const content: HTMLElement = this.getContentElement();
    if (btnOpen && btnClose && content) {
      btnOpen.removeEventListener('click', this.handleClickOpen);
      btnClose.removeEventListener('click', this.handleClickClose);
    }
  }

  private getContentElement = (): HTMLElement => {
    return this.elRoot.querySelector("[data-slot='content']");
  };

  private getOpenElement = (): HTMLElement => {
    return this.elRoot.querySelector("[data-slot='open']");
  };

  private getCloseElement = (): HTMLElement => {
    return this.elRoot.querySelector("[data-slot='close']");
  };

  private handleClickOpen = () => {
    const btnOpen: HTMLElement = this.getOpenElement();
    const btnClose: HTMLElement = this.getCloseElement();
    const content: HTMLElement = this.getContentElement();
    content.style.display = this.dataContentDisplay;
    btnOpen.style.display = 'none';
    btnClose.style.display = this.dataButtonDisplay;
  };

  private handleClickClose = () => {
    const btnOpen: HTMLElement = this.getOpenElement();
    const btnClose: HTMLElement = this.getCloseElement();
    const content: HTMLElement = this.getContentElement();
    btnOpen.style.display = this.dataButtonDisplay;
    btnClose.style.display = 'none';
    content.style.display = 'none';
  };

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
